import React from 'react'


export default function Icon(props){
	return(
		<div className="page-icon">
			{props.text}
		</div>
		)
}